import { ENV } from '@/config/env'
import { getUserFromLocalStorage } from './storage'
import { getUserDataRegion } from '@/lib/auth-service'

export const getRegionBasedBaseUrl = (region: string) => {
  if (region.includes('us')) {
    return ENV.BASE_URL_US
  } else if (region.includes('eu')) {
    return ENV.BASE_URL_EU
  }
  return ENV.BASE_URL_DEFAULT
}

export const getRegionBasedBaseUrlFromUserRegion = async () => {
  const user = getUserFromLocalStorage()
  const email = user?.userInfo.user.email

  if (!email) {
    return ENV.BASE_URL_DEFAULT
  }

  const region = await getUserDataRegion(email)
  if (region.includes('us')) {
    return ENV.BASE_URL_US
  } else if (region.includes('eu')) {
    return ENV.BASE_URL_EU
  }
  return ENV.BASE_URL_DEFAULT
}

export const getRegionBasedNestApiUrl = (region: string) => {
  if (region.includes('us')) {
    return ENV.NEST_API_URL_US
  } else if (region.includes('eu')) {
    return ENV.NEST_API_URL_EU
  }
  return ENV.NEST_API_URL_DEFAULT
}

export const getRegionBasedSupabaseUrl = (region: string) => {
  if (region.includes('us')) {
    return ENV.SUPABASE_URL_US
  } else if (region.includes('eu')) {
    return ENV.SUPABASE_URL_EU
  }
  return ENV.SUPABASE_URL_DEFAULT
}

export const getRegionBasedSupabaseAnonKey = (region: string) => {
  if (region.includes('us')) {
    return ENV.SUPABASE_ANON_KEY_US
  } else if (region.includes('eu')) {
    return ENV.SUPABASE_ANON_KEY_EU
  }
  return ENV.SUPABASE_ANON_KEY_DEFAULT
}

export const getRegionBasedWebsocketUrl = (region: string) => {
  if (region.includes('us')) {
    return ENV.WEBSOCKET_URL_US
  } else if (region.includes('eu')) {
    return ENV.WEBSOCKET_URL_EU
  }
  return ENV.WEBSOCKET_URL_DEFAULT
}
